import {buildActionObject} from "../../../utils/actions_utils";
import {NEW_NOTIFICATION_RECEIVED} from "../../../values/action_types";

export const newNotificationReceived = notification => buildActionObject(NEW_NOTIFICATION_RECEIVED, {notification});